import styled from 'styled-components';
import { typography, color } from 'styles/settings';
import { withModifiers } from 'utils/styles';
import _GlobalLinkZoneModal from 'components/canvas/components/global-link-zone-indicator/components/global-link-zone-modal';

// These are generic styles for the right-menu buttons
// These should be overriden for individual buttons (ex: bulk-select/button.tsx)

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin-top: 150px;
  }
`;

export const Balloon = styled.div`
  ${typography.font.title.bold};
  font-size: ${typography.size.md};
  color: ${color.neutral.white};
  text-align: center;
  line-height: 30px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  position: absolute;
  top: -15px;
  left: -15px;

  background-color: ${color.brand.blue};
  color: ${color.neutral.white};
  border: 1px solid transparent;
  box-sizing: border-box;
`;

export const Button = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  box-shadow: 0px 2px 5px #00000014;
  border-radius: 2px 10px 2px 2px;
  background-color: ${color.neutral.white};
  cursor: pointer;

  opacity: 0;
  transition: opacity 0.5s ease-in;
  color: ${color.brand.blue};

  :hover {
    color: ${color.neutral.white};
    background-color: ${color.brand.blue};
  }

  ${withModifiers('isVisible')`
    opacity: 1;
  `};

  ${withModifiers('alternativeColorScheme')`
    background-color: ${color.brand.blue};
    color: ${color.neutral.white};

    ${Balloon} {
        border: 1px solid ${color.neutral.white};
    }
`}
`;

export const Icon = styled.div`
  width: 30px;
  height: 30px;
  margin: 15px;
  box-sizing: border-box;
  padding: 3px 0 0 3px;
`;

export const GlobalLinkZoneModal = styled(_GlobalLinkZoneModal)`
  @media all and (min-width: 1200px) {
    width: 960px;
  }
`;
